exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mat-card .mat-card-content {\n\theight: 339px;\n\toverflow-y: auto;\n\tpadding-right: 24px;\n}\n\n.tasks .mat-card-content {\n\theight: 800px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/dnbdashboard/dnbdashboard.component.css
// module id = 1944
// module chunks = 0